import { tripPlannerLandingPageComponent } from './trip-planner-landing-page.component';

export const tripPlannerLandingPage = angular
     .module('components.tripPlanner.tripPlannerLandingPage', [])
     .component('tripPlannerLandingPage', tripPlannerLandingPageComponent)
     .config(($stateProvider) => {
     	'ngInject';

     	$stateProvider
		.state('tripPlannerLandingPage', {
			url: '/trip-planner',
			component: 'tripPlannerLandingPage',
			breadcrumbName: 'Trip Planner',
			parentState: 'Home',
			resolve: {
				details(TripPlannerService) {
					'ngInject';

					return TripPlannerService.getTripPlanningLandingPageDetails();
				}
            }
		});
     })
     .name;


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-landing-page/trip-planner-landing-page.module.js